import { YearMonthInput } from '@wrisk/ui-components'
import React, { FunctionComponent, useMemo } from 'react'

import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { FormInputProps } from '../types'

const tKey = TKey('components.year-month-input')

export const YearMonthFormInput: FunctionComponent<FormInputProps<string>> = ({
  validation,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const placeholdersTranslated = useMemo(
    () => ({
      month: t(tKey('month')),
      year: t(tKey('year')),
    }),
    [t],
  )

  return (
    <YearMonthInput
      {...props}
      earliestYear={validation?._self?.minYear as number}
      monthsAhead={1}
      placeholders={placeholdersTranslated}
    />
  )
}
